/* RAJATHEE: Free saree gift popup. Opens after a saree is added to cart and lets the
   shopper add a Gift Edit saree that the "Free Saree on Rs 3,000+" automatic discount makes free.
   Data (gift variants, threshold, rule) comes from snippets/rj-free-gift.liquid.
   Shopify BXGY never counts the free item toward the Rs 3,000, so the gift is only offered
   once the cart (before adding the gift) has reached the threshold.
   Opens on every add-to-cart, and on cart quantity changes only when they unlock the gift
   (quantity-change prompts stay quiet after the shopper has closed the unlocked popup).
   Any element with data-rjfg-open (e.g. the cart gift bar button) opens it on demand. */
(function () {
  if (window.__rjFreeGift) return;
  window.__rjFreeGift = true;
  var dataEl = document.getElementById('rj-free-gift-data');
  if (!dataEl) return;
  var D;
  try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
  if (!D.items || !D.items.length) return;
  var GIFT = {};
  D.items.forEach(function (i) { GIFT[i.id] = true; });
  var nativeFetch = window.fetch.bind(window);
  var suppress = false;
  var dlg = null;

  function money(c) { return '₹' + Math.round(c / 100).toLocaleString('en-IN'); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]; }); }
  function ss(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); } catch (e) { return null; } }

  window.fetch = function (input, init) {
    var p = nativeFetch(input, init);
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var isAdd = /\/cart\/add(\.js)?(\?|$)/.test(url);
      var isQty = /\/cart\/(change|update)(\.js)?(\?|$)/.test(url);
      if (!suppress && isQty) p.then(function (r) { if (r && r.ok) setTimeout(function () { check(true); }, 700); }).catch(function () {});
      if (!suppress && isAdd) {
        var isAddon = false, b = init && init.body;
        if (b) {
          var s = '';
          if (typeof FormData !== 'undefined' && b instanceof FormData) { b.forEach(function (v, k) { s += ' ' + k + ' ' + (typeof v === 'string' ? v : ''); }); }
          else s = String(b);
          isAddon = s.indexOf('_parent_key') !== -1;
        }
        if (!isAddon) p.then(function (r) { if (r && r.ok) setTimeout(function () { check(false); }, 700); }).catch(function () {});
      }
    } catch (e) {}
    return p;
  };

  function isClaimed(item) {
    var a = (item.line_level_discount_allocations || []).concat(item.discounts || []);
    return a.some(function (d) {
      var t = (d.discount_application && d.discount_application.title) || d.title || '';
      return d.amount > 0 && t === D.title;
    });
  }

  window.rjFreeGiftOpen = function () { ss('rj_fg_dismissed', null); check(false); };
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('[data-rjfg-open]')) { e.preventDefault(); window.rjFreeGiftOpen(); }
  });

  function check(onlyUnlocked) {
    nativeFetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var lines = cart.items.filter(function (i) { return !(i.properties && i.properties._parent_key); });
      if (!lines.length || lines.some(isClaimed)) return;
      var qual = lines.reduce(function (s, i) { return s + ((D.countGifts || !GIFT[i.variant_id]) ? i.original_line_price : 0); }, 0);
      var unlocked = qual >= D.threshold;
      if (onlyUnlocked && !unlocked) return;
      if (onlyUnlocked && ss('rj_fg_dismissed') === 'unlocked') return;
      var inCart = {};
      lines.forEach(function (i) { inCart[i.variant_id] = true; });
      show(qual, unlocked, inCart);
    }).catch(function () {});
  }

  function build() {
    var st = document.createElement('style');
    st.textContent = [
      '.rjfg{border:0;padding:0;margin:auto;width:min(560px,94vw);max-height:88vh;border-radius:16px;background:#F5F0E8;color:#1a204b;box-shadow:0 20px 60px rgba(0,0,0,.3);overflow:hidden;font-family:var(--font-body--family,inherit)}',
      '.rjfg::backdrop{background:rgba(26,32,75,.55)}',
      '.rjfg__in{position:relative;padding:28px 0 20px;max-height:88vh;overflow-y:auto;box-sizing:border-box}',
      '.rjfg__x{position:absolute;top:10px;right:12px;width:36px;height:36px;border:0;background:transparent;font-size:26px;line-height:1;color:#1a204b;cursor:pointer;border-radius:50%}',
      '.rjfg__x:hover{background:rgba(26,32,75,.08)}','.rjfg__x:focus{outline:none}','.rjfg__x:focus-visible{background:rgba(26,32,75,.1)}',
      '.rjfg__head{padding:0 24px;text-align:center}',
      '.rjfg__eye{margin:0 0 6px;font-size:11px;letter-spacing:.18em;text-transform:uppercase;color:#a8834a;font-weight:600}',
      '.rjfg__h{margin:0 0 8px;font-family:var(--font-heading--family,Georgia,serif);font-size:26px;line-height:1.2;font-weight:500;color:#1a204b}',
      '.rjfg__h em{font-style:italic;color:#8B1A1A}',
      '.rjfg__sub{margin:0 auto;max-width:400px;font-size:14px;line-height:1.5;color:#4a4a5a}',
      '.rjfg__bar{margin:16px auto 0;max-width:360px}',
      '.rjfg__track{height:6px;background:#e0d5c5;border-radius:3px;overflow:hidden}',
      '.rjfg__fill{height:100%;background:#C9A96E;border-radius:3px;transition:width .4s ease}',
      '.rjfg__barlbl{display:flex;justify-content:space-between;margin-top:6px;font-size:11.5px;color:#6b6b7a}',
      '.rjfg__list{display:flex;gap:12px;overflow-x:auto;scroll-snap-type:x mandatory;scroll-padding-inline:24px;padding:20px 24px 6px;-webkit-overflow-scrolling:touch}',
      '.rjfg__card{flex:0 0 150px;scroll-snap-align:start;background:#fff;border-radius:10px;overflow:hidden;box-shadow:0 1px 3px rgba(0,0,0,.06);display:flex;flex-direction:column}',
      '.rjfg__img{display:block;aspect-ratio:3/4;overflow:hidden;background:#ece5da}',
      '.rjfg__img img{width:100%;height:100%;object-fit:cover;display:block}',
      '.rjfg__body{padding:10px 10px 12px;display:flex;flex-direction:column;gap:4px;flex:1}',
      '.rjfg__name{margin:0;font-size:13px;line-height:1.3;font-weight:600;color:#1a204b}',
      '.rjfg__var{margin:0;font-size:11.5px;color:#6b6b7a}',
      '.rjfg__price{margin:2px 0 6px;font-size:12px;display:flex;gap:6px;align-items:baseline}',
      '.rjfg__price s{color:#9a9aa6}',
      '.rjfg__free{font-weight:700;color:#2d7a4f;letter-spacing:.04em}',
      '.rjfg__add{margin-top:auto;width:100%;padding:9px 6px;border:0;border-radius:8px;background:#1a204b;color:#F5F0E8;font:inherit;font-size:12.5px;font-weight:600;cursor:pointer}',
      '.rjfg__add:hover{background:#C9A96E;color:#1a204b}',
      '.rjfg__add[disabled]{opacity:.6;cursor:default;background:#1a204b;color:#F5F0E8}',
      '.rjfg__lock{margin-top:auto;font-size:11px;color:#8a7560;text-align:center;padding:6px 0 2px}',
      '.rjfg__foot{display:flex;gap:10px;padding:14px 24px 0}',
      '.rjfg__btn{flex:1;padding:12px;border-radius:10px;font:inherit;font-size:13.5px;font-weight:600;text-align:center;text-decoration:none;cursor:pointer;border:1px solid #1a204b}',
      '.rjfg__btn--p{background:#1a204b;color:#F5F0E8}',
      '.rjfg__btn--s{background:transparent;color:#1a204b}',
      '.rjfg__note{margin:12px 24px 0;text-align:center;font-size:11px;color:#8a8a96}',
      '@media (max-width:749px){.rjfg{width:100vw;max-width:100vw;margin:auto 0 0;border-radius:18px 18px 0 0}.rjfg__h{font-size:22px}.rjfg__card{flex-basis:136px}}'
    ].join('');
    document.head.appendChild(st);
    dlg = document.createElement('dialog');
    dlg.className = 'rjfg';
    dlg.setAttribute('aria-labelledby', 'rjfg-h');
    document.body.appendChild(dlg);
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg) { dismiss(); return; }
      var add = e.target.closest('[data-rjfg-add]');
      if (add) { addGift(parseInt(add.getAttribute('data-rjfg-add'), 10), add); return; }
      if (e.target.closest('[data-rjfg-close]')) dismiss();
      if (e.target.closest('[data-rjfg-cart]')) { close(); openCart(); }
    });
    dlg.addEventListener('cancel', function (e) { e.preventDefault(); dismiss(); });
  }

  function show(qual, unlocked, inCart) {
    if (!dlg) build();
    dlg.dataset.state = unlocked ? 'unlocked' : 'locked';
    var remaining = Math.max(D.threshold - qual, 0);
    var pct = Math.min(100, Math.round(qual * 100 / D.threshold));
    var head = unlocked
      ? '<p class="rjfg__eye">The Gift Edit</p><h2 class="rjfg__h" id="rjfg-h">You’ve unlocked a <em>free saree</em></h2><p class="rjfg__sub">Pick any one saree below and add it to your cart. It becomes ₹0 at checkout.</p>'
      : '<p class="rjfg__eye">The Gift Edit</p><h2 class="rjfg__h" id="rjfg-h">Your next saree can be <em>free</em></h2><p class="rjfg__sub">Shop ' + money(D.threshold) + ' or more and pick any one saree below, free. You’re just <strong>' + money(remaining) + '</strong> away.</p>' +
        '<div class="rjfg__bar"><div class="rjfg__track"><div class="rjfg__fill" style="width:' + pct + '%"></div></div><div class="rjfg__barlbl"><span>' + money(qual) + ' in cart</span><span>' + money(D.threshold) + '</span></div></div>';
    var cards = D.items.filter(function (g) { return !inCart[g.id]; }).map(function (g) {
      var mrp = g.compare > g.price ? g.compare : g.price;
      var action = unlocked
        ? '<button type="button" class="rjfg__add" data-rjfg-add="' + g.id + '">Add free</button>'
        : '<p class="rjfg__lock">Free once you reach ' + money(D.threshold) + '</p>';
      return '<div class="rjfg__card"><a class="rjfg__img" href="' + esc(g.url) + '"><img src="' + esc(g.image) + '" alt="' + esc(g.name) + '" loading="lazy" width="300" height="400"></a>' +
        '<div class="rjfg__body"><p class="rjfg__name">' + esc(g.product) + '</p>' + (g.variant && g.variant !== 'Default Title' ? '<p class="rjfg__var">' + esc(g.variant) + '</p>' : '') +
        '<p class="rjfg__price"><s>' + money(mrp) + '</s><span class="rjfg__free">FREE</span></p>' + action + '</div></div>';
    }).join('');
    var foot = unlocked
      ? '<button type="button" class="rjfg__btn rjfg__btn--s" data-rjfg-close>Maybe later</button><button type="button" class="rjfg__btn rjfg__btn--p" data-rjfg-cart>View cart</button>'
      : '<button type="button" class="rjfg__btn rjfg__btn--s" data-rjfg-cart>View cart</button><a class="rjfg__btn rjfg__btn--p" href="' + esc(D.shopUrl) + '">Continue shopping</a>';
    dlg.innerHTML = '<div class="rjfg__in"><button type="button" class="rjfg__x" aria-label="Close" data-rjfg-close>&times;</button><div class="rjfg__head">' + head + '</div><div class="rjfg__list">' + cards + '</div><div class="rjfg__foot">' + foot + '</div><p class="rjfg__note">One free saree per order. While stocks last.</p></div>';
    if (!cards) return;
    if (dlg.open) dlg.close();
    try { dlg.showModal(); } catch (e) { dlg.setAttribute('open', ''); }
  }

  function close() { if (dlg && dlg.open) dlg.close(); }
  function dismiss() { if (dlg) ss('rj_fg_dismissed', dlg.dataset.state); close(); }

  function openCart() {
    var drawer = document.querySelector('cart-drawer-component');
    if (drawer && typeof drawer.open === 'function') { drawer.open(); return; }
    var trig = document.querySelector('[data-testid="cart-drawer-trigger"]');
    if (trig) { trig.click(); return; }
    window.location.href = '/cart';
  }

  function addGift(id, btn) {
    btn.disabled = true;
    btn.textContent = 'Adding…';
    var ids = Array.from(new Set(Array.from(document.querySelectorAll('cart-items-component[data-section-id]')).map(function (e) { return e.dataset.sectionId; }).filter(Boolean)));
    var body = { items: [{ id: id, quantity: 1 }] };
    if (ids.length) body.sections = ids.join(',');
    suppress = true;
    nativeFetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        suppress = false;
        if (!res.ok) { btn.textContent = 'Sold out'; return; }
        if (res.j.sections) Object.keys(res.j.sections).forEach(function (sid) {
          var el = document.querySelector('[data-section-id="' + sid + '"]');
          if (!el || !res.j.sections[sid]) return;
          var n = new DOMParser().parseFromString(res.j.sections[sid], 'text/html').querySelector('[data-section-id="' + sid + '"]');
          if (n) el.innerHTML = n.innerHTML;
        });
        return nativeFetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'rj-free-gift', itemCount: cart.item_count, data: { source: 'rj-free-gift', itemCount: cart.item_count } } }));
          ss('rj_fg_dismissed', null);
          close();
          openCart();
        });
      })
      .catch(function () { suppress = false; btn.disabled = false; btn.textContent = 'Try again'; });
  }
})();
